/**
 * CheckoutBuyNowMixin — Buy Now checkout logic extracted from Checkout.vue.
 *
 * Provides:
 *   - data: buyNowOrderData
 *   - computed: isBuyNowFlow, buyNowOrderId
 *   - methods: fetchBuyNowOrder, onBuyNowDone, onBuyNowError
 *
 * Expects the host component to provide:
 *   - computed: getOrderQuery
 *   - data: fetching, fetchError
 */
export default {
  data() {
    return {
      buyNowOrderData: null,
    };
  },
  computed: {
    isBuyNowFlow() {
      return this.$route.query.flow === 'buyNow';
    },
    buyNowOrderId() {
      return this.$store.state.cart.buyNowOrder;
    },
  },
  methods: {
    async fetchBuyNowOrder() {
      if (!this.buyNowOrderId) return;
      this.fetching = true;
      this.fetchError = null;
      try {
        const result = await this.$apollo.query({
          query: this.getOrderQuery,
          variables: { orderId: this.buyNowOrderId },
          fetchPolicy: 'network-only',
        });
        const order = result.data?.order;
        if (!order) {
          this.$store.commit('clearBuyNow');
          this.$router.push({ name: 'home' });
        } else {
          this.buyNowOrderData = order;
        }
      } catch (e) {
        if (!this.buyNowOrderData) this.fetchError = e;
      } finally {
        this.fetching = false;
      }
    },
    onBuyNowDone(result) {
      const order = result?.data?.placeBuyNowOrder?.order;
      if (order) {
        const safaricomMpesaRequestId = order.newSafaricomMpesaRequest?.id;
        this.$router.push({
          name: 'orderPending',
          params: {
            id: order.id,
            safaricomMpesaRequestId: safaricomMpesaRequestId,
          },
          query: { flow: 'buyNow' },
        });
      }
    },
    onBuyNowError(error) {
      this.$store.dispatch('snackbar/showSnackbar', {
        text: error.message || this.$t('errors.unexpectedError'),
        color: 'error',
      });
    },
  },
};
